import { memo, type ReactElement } from 'react'

function JumpIcon (): ReactElement {
  return (
    <svg
      className="h-4 flex self-center"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-883 -621)">
          <g transform="translate(341 197)">
            <g transform="translate(286 406)">
              <g transform="translate(.5)">
                <g transform="translate(73.5 17)">
                  <path
                    d="M200.197 8.41l-6.572 6.571a.441.441 0 01-.507.104.47.47 0 01-.29-.432v-3.286h-1.409c-.244 0-5.905.056-8.018 5.342a.46.46 0 01-.432.291h-.084a.46.46 0 01-.385-.47c0-4.083 1.127-7.182 3.352-9.22a10.581 10.581 0 016.975-2.515V1.509a.47.47 0 01.291-.47.441.441 0 01.507.104l6.572 6.572a.45.45 0 010 .694z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default memo(JumpIcon)
